export const MOBILE_FERNIE_PATH = "/fernie";
